import { Button } from '../../ui/button';
import { Label } from '../../ui/label';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from '../../ui/dialog';
import { Checkbox } from '../../ui/checkbox';
import { EditRolesDialogProps } from './userTypes';

export function EditRolesDialog({
  open,
  onOpenChange,
  selectedUser,
  roleCatalog,
  editRoles,
  setEditRoles,
  loading,
  onSubmit
}: EditRolesDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Editar papeis</DialogTitle>
          <DialogDescription>
            Altere os papeis de acesso de {selectedUser?.name}.
          </DialogDescription>
        </DialogHeader>

        <form onSubmit={onSubmit} className="space-y-3">
          <Label>Papeis de acesso</Label>
          <div className="space-y-2">
            {roleCatalog.map((role) => (
              <label
                key={role.id}
                className="flex items-start gap-3 rounded-lg border border-border bg-background px-3 py-2"
              >
                <Checkbox
                  checked={editRoles.includes(role.id)}
                  onCheckedChange={() => {
                    setEditRoles((current) =>
                      current.includes(role.id)
                        ? current.filter((r) => r !== role.id)
                        : [...current, role.id]
                    );
                  }}
                  className="mt-1"
                />
                <div>
                  <p className="text-sm font-medium">{role.label}</p>
                  <p className="text-xs text-muted-foreground">
                    {role.description}
                  </p>
                </div>
              </label>
            ))}
          </div>

          <DialogFooter>
            <Button
              variant="outline"
              type="button"
              onClick={() => onOpenChange(false)}
              disabled={loading}
            >
              Cancelar
            </Button>
            <Button
              type="submit"
              disabled={loading || editRoles.length === 0}
            >
              {loading ? 'Salvando...' : 'Salvar'}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
